export default "/images/umibozu-button.png?84dbcc5f595127492e739bb3ae67ae6a";